import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=b674333a&scoped=true"
import script from "./Wait.vue?vue&type=script&lang=ts"
export * from "./Wait.vue?vue&type=script&lang=ts"
import style0 from "./Wait.vue?vue&type=style&index=0&id=b674333a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b674333a",
  null
  
)

export default component.exports